<template lang="pug">
section(
  class='gallery'
  :class="{ busy: sorting }"
)
  s-page-title(title='Галерея')
    template(slot='extension')
      v-btn(@click='onEdit()' color='primary' depressed) Создать
  template(v-if='!isLoading')
    div(v-for='(gallery, siteName) in listTreeStruct')
      v-card(class='mb-4')
        v-container(grid-list-xl fluid)
          v-layout(wrap)
            v-flex(xs12)
              div(class='title') {{siteName}}
            v-flex(xs12)
              gallery-list(:items='createTree(gallery)')
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { createTreeStruct } from '@/utils'
import GalleryList from './GalleryList'
import http from '@/http'
import emitter from '@/emitter'

export default {
  components: { GalleryList },

  data: () => ({
    sorting: false,
    busy: false
  }),

  created() {
    this.fetchList()
  },

  mounted() {
    emitter.$on('gallery.sort', this.onSort)
    emitter.$on('gallery.edit', this.onEdit)
    emitter.$on('gallery.create', this.onCreate)
    emitter.$on('gallery.delete', this.onDelete)
    emitter.$on('gallery.publishState', this.onPublishState)
  },

  destroyed() {
    emitter.$off('gallery.sort', this.onSort)
    emitter.$off('gallery.edit', this.onEdit)
    emitter.$off('gallery.create', this.onCreate)
    emitter.$off('gallery.delete', this.onDelete)
    emitter.$off('gallery.publishState', this.onPublishState)
  },

  methods: {
    createTree(data) {
      return createTreeStruct(data)
    },

    onEdit({ id } = {}) {
      this.$router.push({
        name: 'Content.Gallery.Edit',
        params: { id }
      })
    },

    onCreate({ id }) {
      this.$router.push({
        name: 'Content.Gallery.Edit',
        params: { id },
        query: { parentId: id }
      })
    },

    async onDelete({ id }) {
      if (!(await this.$confirm('Вы уверены?'))) return

      try {
        await this.destroy({ id })
      } catch (e) {
        this.$root.showSnack('Ошибка удаления')
      }

      this.fetchList()
    },

    async onPublishState({ id,published }) {
      try {
        if (this.busy) return
        this.busy = true
        try {
          const newStatus = published ? 'unpublish' : 'publish'
          await http.post(`/gallery/${id}/${newStatus}`)
        } catch (error) {
          this.$root.showSnack('Ошибка обновления статуса')
        } finally {
          this.busy = false
        }
      } catch (e) {
        this.$root.showSnack('Ошибка удаления')
      }

      
    },

    async onSort(indexes) {
      this.sorting = true

      try {
        await http.post('/gallery/sort-ref', { albums: indexes })
      } catch (e) {
        this.$root.showSnack('Ошибка сортировки')
      }

      this.sorting = false
    },

    ...mapActions('content/gallery', ['fetchList', 'destroy'])
  },

  computed: {
    listTreeStruct() {
      return this.list.reduce((acc, cur) => {
        acc[cur.site_name] || (acc[cur.site_name] = [])
        acc[cur.site_name].push(cur)
        return acc
      }, {})
    },

    ...mapState('content/gallery', ['total']),
    ...mapGetters('content/gallery', ['list', 'isLoading'])
  }
}
</script>

<style scoped>
.busy {
  pointer-events: none;
}
.gallery >>> .v-treeview-node__label:first-letter {
  text-transform: uppercase;
}
</style>
